import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { faChevronLeft, faChevronRight } from '../../../icons';
@Component({
    selector: 'app-ios-location-tutorial',
    templateUrl: './ios-location-tutorial.component.html',
    styleUrls: ['./ios-location-tutorial.component.scss'],
    standalone: false
})
export class IosLocationTutorialComponent implements OnInit {
      faChevronRight = faChevronRight;
    faChevronLeft = faChevronLeft;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onSend: EventEmitter<any> = new EventEmitter();
  @ViewChild('iosTutorialModal', { static: true }) elModal;

  modalRef: NgbModalRef;

  nSteps = 5;
  curStep = 1;
  baseImgPath: string = "/assets/images/tutorial-ios";
  imgPath: string;

  constructor(private modalService: NgbModal) { }

  openModal() {
    this.modalRef = this.modalService.open(this.elModal);
  }

  ngOnInit() {
    this.setImgPath();
  }

  send() {
    this.modalRef.close();
  }

  nextStep() {
    this.curStep += 1;
    this.setImgPath();
  }
  prevStep() {
    this.curStep -= 1;
    this.setImgPath();
  }

  setImgPath() {
    this.imgPath = this.baseImgPath + `/step${this.curStep}.jpeg`;
  }
}
